import {Col, Row} from "antd";
import {
	Icon,
	Button,
} from "~/components";
import {
	renderDate
} from "~/utils";
import {useCan} from "~/hooks";

function CustomerFormInfo({item, onClickStatus})
{
	const can = {
		status: useCan('customerStatus'),
	};

	const renderCompanyInfo = (item) => {
		return (
			<>
				<p className="heading">Thông tin công ty</p>
				<Row className="mb-2" gutter={10}>
					<Col className="gutter-row" span={6}>Tên công ty</Col>
					<Col className="gutter-row" span={18}>{item.companyName}</Col>
				</Row>
				<Row className="mb-2" gutter={10}>
					<Col className="gutter-row" span={6}>Mã số thuế</Col>
					<Col className="gutter-row" span={18}>{item.taxCode}</Col>
				</Row>
				<Row className="mb-2" gutter={10}>
					<Col className="gutter-row" span={6}>Địa chỉ</Col>
					<Col className="gutter-row" span={18}>{`${item.companyAddress}, ${item?.companyAddressFull}`}</Col>
				</Row>
			</>
		)
	}
	const renderCustomerInfo = (item) => {
		return (
			<>
				<p className="heading">Thông tin khách hàng</p>
				<Row className="mb-2" gutter={10}>
					<Col className="gutter-row" span={6}>Tên khách hàng</Col>
					<Col className="gutter-row" span={18}>{item.name}</Col>
				</Row>
				<Row className="mb-2" gutter={10}>
					<Col className="gutter-row" span={6}>Số CCCD/CMND</Col>
					<Col className="gutter-row" span={18}>{item.numberId}</Col>
				</Row>
				<Row className="mb-2" gutter={10}>
					<Col className="gutter-row" span={6}>Email</Col>
					<Col className="gutter-row" span={18}>{item.email}</Col>
				</Row>
				<Row className="mb-2" gutter={10}>
					<Col className="gutter-row" span={6}>Phone</Col>
					<Col className="gutter-row" span={18}>{item.phone}</Col>
				</Row>
				<Row className="mb-2" gutter={10}>
					<Col className="gutter-row" span={6}>Địa chỉ</Col>
					<Col className="gutter-row" span={18}>{`${item.address}, ${item?.addressFull}`}</Col>
				</Row>
				<Row className="mb-2" gutter={10}>
					<Col className="gutter-row" span={6}>Sinh nhật</Col>
					<Col className="gutter-row" span={18}>{renderDate(item.birthday)}</Col>
				</Row>
				<Row className="mb-2" gutter={10}>
					<Col className="gutter-row" span={6}>Giới tính</Col>
					<Col className="gutter-row" span={18}>{item.gender}</Col>
				</Row>
			</>
		)
	}
	const handleStatusClick = (item) => {
		if(!onClickStatus) return;
		onClickStatus(item);
	}

	return (
		<div className="form">
			{item.for === 'congty' && renderCompanyInfo(item)}
			{renderCustomerInfo(item)}
			<hr />
			<div className="form-group d-flex justify-content-end modal-bottom">
				{
					(can.status && item.status.key === 'pending') && (<Button onClick={() => handleStatusClick(item)} background green leftIcon={Icon.success}>Duyệt khách hàng</Button>)
				}
				{
					(can.status && item.status.key === 'confirm') && (<Button onClick={() => handleStatusClick(item)} background white leftIcon={Icon.arrowLeft}>Bỏ duyệt khách hàng</Button>)
				}
			</div>
		</div>
	)
}

export default CustomerFormInfo;